module.exports = parcelRequire.resolve("8gH0P");